
import { makeAutoObservable } from 'mobx';
import { XtLocale,Util } from '@xt/xtbase';
import { get_balances,get_not_novice } from '@/api/v4/finance';
const {Big} = Util;
export default class Finance {

  scope:string = "";

  loading:boolean = false;

  assets: {} = {};
  showSubscribe: {} = null;

  parent: any = null;

  isNewer: boolean = false;
  isNewerLoading:boolean = false;

  constructor(parent) {
    this.parent = parent;
    makeAutoObservable(this);
  }

  setScope(scope){
    this.scope = scope;
  }

  async getAssets() {
    if(this.loading)
      return;
    this.loading = true;

    const data: any = await get_balances({
      params: {
        scope: this.scope,
      }
    }).finally(() => {
      this.loading = false;
    });

    if (data) {
      this.assets = data;
    }
  }
  
  async getIsNewer() {
    if(this.isNewerLoading)
      return;
    this.isNewerLoading = true;

    const data: any = await get_not_novice().finally(() => {
      this.isNewerLoading = false;
    });

    if (data)
      this.isNewer = false;
    else
      this.isNewer = true;
  }

  setIsNewer(b){
    this.isNewer = b;
  }

  getYearlyProfitLaunchPool(product, subscribed, inputValue){
    if(!this.parent || !this.parent.fund)
      return "";
    if(!subscribed)
      subscribed = product.subscribed;
    if(inputValue)
      subscribed += inputValue;
    const fund = this.parent.fund;
    const {currency,interestCurrency,totalReward,duration,rewardPercent} = product;
    var a = 100*fund.getCoinValue(365*totalReward*rewardPercent/100,(interestCurrency || "").toLowerCase());
    var totalQuota = subscribed > 0 ? subscribed : product.totalQuota;
    var b = fund.getCoinValue(duration*totalQuota,(currency || "").toLowerCase());
    return b > 0 ? new Big(a/b).toFixed(2)+"%" : "--%";
  }

  getYearlyProfitHashRate(product){
    if(!this.parent || !this.parent.fund)
      return "";
    const fund = this.parent.fund;
    const {currency,interestCurrency,totalQuota,managementFee,dailyMinOutput,dailyMaxOutput,productPrice,duration} = product;
    var p = (1-managementFee/100);
    var min = fund.getCoinValue(dailyMinOutput/totalQuota,(interestCurrency || "").toLowerCase());
    var max = fund.getCoinValue(dailyMaxOutput/totalQuota,(interestCurrency || "").toLowerCase());
    if(min == 0 && max == 0)
      return "--%";
    var x = fund.getCoinValue(productPrice/duration,(currency || "").toLowerCase());
    return x > 0 ? new Big(100*(min/x*p-1)).toFixed(2)+"% ~ "+new Big(100*(max/x*p-1)).toFixed(2)+"%" : "--%";
  }

  getProductNameHashRate(product){
    if(!product || !product.productNames)
      return "";
    const langCode = XtLocale.getLangCode();
    const productNames = product.productNames;
    var enName = null;
    var name = null;
    for(var i in productNames)
    {
      if(productNames[i].language == "en")
      {
        enName = productNames[i].name;
      }
      if(productNames[i].language == langCode)
      {
        name = productNames[i].name;
        break;
      }
    }
    return name || enName || "";
  }
}
